export const apiEndpoint = {
  pdfBaseUri: "https://pdf.meon.co.in",
  esignBaseUri: "https://esign.meon.co.in",
  developerToolBaseUri: window.location.host.includes("localhost")
    ? "https://developer.meon.co.in"
    : "https://developer.meon.co.in",
};
